import React, { useState } from "react";
import { generateCoupon, COUPON_CONFIG } from "../../data/coupons";
import { printHtml } from "../../data/print";
import { useAuth } from "../../context/AuthContext";

const CouponOfferModal = ({ show, onClose, orderId, total }) => {
  const { user } = useAuth();
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const c = await generateCoupon({
        orderId,
        total,
        cashierId: user?.id || "unknown",
        cashierName: user?.user_metadata?.full_name || user?.email || "Caissier",
      });
      setCoupon(c);
    } catch (err) {
      console.error("Failed to generate coupon:", err);
    }
    setLoading(false);
  };

  const handlePrint = () => {
    if (!coupon) return;
    const expires = new Date(coupon.expires_at).toLocaleDateString("fr-FR");
    const html = `<!DOCTYPE html>
<html><head><style>
  body { font-family: monospace; text-align: center; padding: 20px; }
  .code { font-size: 24px; font-weight: bold; letter-spacing: 3px; margin: 15px 0; border: 2px dashed #333; padding: 10px; }
  .details { font-size: 12px; margin-top: 10px; }
  .discount { font-size: 18px; font-weight: bold; color: #16a34a; }
</style></head><body>
  <div>BON DE RÉDUCTION</div>
  <div class="discount">-${coupon.discount.toFixed(2)} €</div>
  <div class="code">${coupon.code}</div>
  <div class="details">
    Valable jusqu'au ${expires}<br>
    Minimum d'achat : ${coupon.minSpend.toFixed(2)} €<br>
    Merci pour votre visite !
  </div>
</body></html>`;
    printHtml(html, { title: "Bon de réduction" });
  };

  const expires = coupon
    ? new Date(coupon.expires_at).toLocaleDateString("fr-FR")
    : "";

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "hidden" }}>
          {!coupon ? (
            <>
              <div className="p-4 text-center" style={{ background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)" }}>
                <i className="bi bi-gift-fill" style={{ fontSize: "3rem", color: "#d97706" }}></i>
              </div>
              <div className="modal-body p-4 text-center">
                <h5 className="fw-bold mb-2" style={{ color: "#1f2937" }}>Offre spéciale client !</h5>
                <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
                  Ce client a depensé <strong>{total.toFixed(2)} €</strong>.<br/>
                  Vous pouvez lui offrir un bon de réduction :
                </p>
                <div className="d-flex justify-content-center gap-4 mb-3">
                  <div className="text-center">
                    <div className="fw-bold fs-3" style={{ color: "#16a34a" }}>-{COUPON_CONFIG.discount.toFixed(2)} €</div>
                    <div className="text-muted" style={{ fontSize: "0.75rem" }}>Réduction</div>
                  </div>
                  <div className="text-center">
                    <div className="fw-bold fs-3" style={{ color: "#2563eb" }}>{COUPON_CONFIG.minSpend.toFixed(0)} €</div>
                    <div className="text-muted" style={{ fontSize: "0.75rem" }}>Achat min.</div>
                  </div>
                  <div className="text-center">
                    <div className="fw-bold fs-3" style={{ color: "#7c3aed" }}>{COUPON_CONFIG.validityWeeks}</div>
                    <div className="text-muted" style={{ fontSize: "0.75rem" }}>Semaines</div>
                  </div>
                </div>
                <button
                  className="btn w-100 py-2 fw-bold text-white mb-2"
                  style={{ backgroundColor: "#d97706", borderRadius: "10px" }}
                  onClick={handleGenerate}
                  disabled={loading}
                >
                  {loading ? "Génération..." : "Générer le bon"}
                </button>
                <button className="btn w-100 py-2 fw-bold" style={{ color: "#6b7280" }} onClick={onClose}>
                  Non merci
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="p-4 text-center" style={{ background: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)" }}>
                <i className="bi bi-check-circle-fill" style={{ fontSize: "3rem", color: "#16a34a" }}></i>
              </div>
              <div className="modal-body p-4 text-center">
                <h5 className="fw-bold mb-1" style={{ color: "#1f2937" }}>Bon généré !</h5>
                <p className="text-muted mb-3" style={{ fontSize: "0.85rem" }}>Remettez ce bon au client</p>

                <div className="p-3 rounded mb-3" style={{ backgroundColor: "#f9fafb", border: "2px dashed #d1d5db" }}>
                  <div style={{ fontSize: "0.75rem", color: "#6b7280", marginBottom: "4px" }}>CODE</div>
                  <div className="fw-bold" style={{ fontSize: "1.5rem", letterSpacing: "3px", color: "#1f2937" }}>{coupon.code}</div>
                  <div className="mt-2" style={{ fontSize: "0.85rem", color: "#16a34a", fontWeight: "600" }}>
                    -{coupon.discount.toFixed(2)} € de réduction
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: "4px" }}>
                    Valable jusqu'au {expires} • Min. {coupon.minSpend.toFixed(2)} €
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button className="btn btn-outline-dark fw-bold flex-grow-1" onClick={handlePrint}>
                    <i className="bi bi-printer me-1"></i> Imprimer
                  </button>
                  <button className="btn fw-bold flex-grow-1 text-white" style={{ backgroundColor: "#22d3ee" }} onClick={onClose}>
                    Fermer
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CouponOfferModal;
